import { all, call, delay, put, take, takeLatest } from "redux-saga/effects";
import * as userActions from "../action/user";
import * as StorageManager from "../utils/StorageManager"
import constants from "../constants";
import { Router } from "react-router";
import PAGE from "../utils/Destination";
import * as authActions from "../action/auth";

function* watcherStartLogoutRequest() {
  try {
      yield call(removeToken)
      yield put(userActions.updateUserDetail())
      yield put(authActions.startLogoutSuccess())

  } catch (err) {
    // handle error message here
  }
}

async function removeToken(){
    await StorageManager.removeToken(constants.AUTH_TOKEN)

}

function* rootSaga() {
  yield all([takeLatest("START_LOGOUT_REQUEST", watcherStartLogoutRequest)]);
}

export default rootSaga;
